module.exports = __webpack_public_path__ + "img/ic-arrow-right-black-big.06361eb5.svg";